const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHomeInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.88,11.39,12,2.53a.82.82,0,0,0-1.08,0L1.12,11.39a.81.81,0,0,0,.54,1.41H3.8v7.06a.81.81,0,0,0,.81.81H9.53a.81.81,0,0,0,.81-.81V14.77h2.32v5.09a.81.81,0,0,0,.81.81h4.92a.81.81,0,0,0,.81-.81V12.8h2.14a.81.81,0,0,0,.54-1.41Zm-3.49-.21a.81.81,0,0,0-.81.81v7.06h-3.3V14a.81.81,0,0,0-.81-.81H9.53a.81.81,0,0,0-.81.81v5.09H5.42V12a.81.81,0,0,0-.81-.81H3.78L11.5,4.23l7.72,7Z",
    style: {
      fill: "#8b8b8b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHomeInactive);
export default __webpack_public_path__ + "static/media/ic-home-inactive.b3f013652c0c0fc3b5af2376c60ce2a2.svg";
export { ForwardRef as ReactComponent };